import { GetPostureReportResponse } from "../../../api/algorithm/posture/posture"
import { CanvasEnum } from "./muscle"
export type Direction = 'front' | 'side' | 'back' | 'otherSide'
export type Level = 'normal' | 'middle' | 'high'
export type CanvasIds = 'front' | 'side' | 'back' | "test"
export type Parts = 'front' | 'side' | 'back'
export type Directions = 'left' | 'right' | 'none' | "front" | 'face' | "side" | "back"
export type PointNames = 'nose' | 'neck' | 'shoulder' | "elbow" | 'wrist' | 'hip' | 'knee' | "ankle" | 'eye' | 'ear' | 'heel'
// export typ    Names = '鼻子'   | '脖子' | '肩膀' |      "肘部" | '手腕'    | '臀部髋' | '膝盖' | "踝关节" | '眼睛' | '耳朵'
export type DirectionPartD = 'nose' | 'neck' | 'shoulderleft' | 'shoulderright'
    | 'elbowleft' | 'elbowright' | 'wristleft' | 'wristright' | 'hipleft' | 'hipright'
    | 'kneeleft' | 'kneeright' | 'ankleleft' | 'ankleright' | 'heelleft' | 'heelright' | 'eyeleft' | 'eyeright'
    | 'earleft' | 'earright' | "hipcenter" | "neckcenter" | "anklecenter"

export const ponintName = {
    nose:"鼻",
    neck:"",
    shoulderleft:"左肩",
    shoulderright:"右肩",
    elbowleft:"左肘",
    elbowright:"右肘",
    wristleft:"左腕",
    wristright:"右腕",
    hipleft:"左髋",
    hipright:"右髋",
    kneeleft:"左膝",
    kneeright:"右膝",
    ankleleft:"左踝",
    ankleright:"右踝",
    heelleft:"左跟",
    heelright:"右跟",
    eyeleft:"左眼",
    eyeright:"右眼",
    earleft:"左耳",
    earright:"右耳",
    hipcenter:"",
    neckcenter:"",
    anklecenter:"",
}
export interface FormatData {
    data: GetPostureReportResponse,
    direction: CanvasEnum
}
type DotArgs = {
    [key in keyof Dot]?: Dot[key]
}
export class Dot {
    fillStyle: string
    radius: number
    lineWith: number
    constructor(args?: DotArgs) {
        let dArgs = { fillStyle: "black", radius: 1, lineWith: 1 };
        let dotArgs = Object.assign(dArgs, args)
        this.fillStyle = dotArgs.fillStyle || ''
        this.radius = dotArgs.radius || 1;
        this.lineWith = dotArgs.lineWith || 1
    }
}
type CircleArgs = {
    [key in keyof Circle]?: Circle[key]
}
export class Circle {
    strokeStyle: string
    radius: number
    lineWith: number
    constructor(args?: CircleArgs) {
        let dArgs = { strokeStyle: "red", radius: 1, lineWith: 1 };
        let circleArgs = Object.assign(dArgs, args)
        this.strokeStyle = circleArgs.strokeStyle || ''
        this.radius = circleArgs.radius || 1;
        this.lineWith = circleArgs.lineWith || 1
    }
}
type TextArgs = {
    [key in keyof Text]?: Text[key]
}
export class Text {
    fillStyle: string
    font: string
    textAligin: string
    constructor(args?: TextArgs) {
        let dArgs = { fillStyle: "#17CD98", font: "16px Arial", textAligin: "center" }
        let textArgs = Object.assign(dArgs, args)
        this.fillStyle = textArgs.fillStyle || ''
        this.font = textArgs.font || "16px Arial"
        this.textAligin = textArgs.textAligin || ""
    }
}
type LineArgs = {
    [key in keyof Line]?: Line[key]
}
export class Line {
    strokeStyle: string
    lineWith: number
    constructor(args?: LineArgs) {
        let dArgs = { strokeStyle: "blue", lineWith: 1 };
        let lineArgs = Object.assign(dArgs, args)
        this.strokeStyle = lineArgs.strokeStyle || ''
        this.lineWith = lineArgs.lineWith || 1
    }
}
export interface DotData {
    score: string | number,
    part: DirectionPartD,
    line: Line,
    name: PointNames,
    pointName:string,
    vline: Line,
    hline: Line,
    text: Text,
    circle: Circle,
    dot: Dot,
    hover?: boolean,
    select?: boolean,
    hCalculateAngle?: boolean,
    lineChildren: Array<DotData>,
    verticalLine: Array<DotData>,
    horizotalLine: Array<DotData>,
    disabled: boolean,
    direction: Direction,
    partDirection: PointNames,
    position: {
        x: number,
        y: number,
        left:{
            x: number,
            y: number,
        },
        right:{
            x: number,
            y: number,
        }
    }
}
export interface DrawCanvasProps {
    canvasId: CanvasEnum
    directon: CanvasEnum,
    data: Array<DotData>
    img:HTMLImageElement
    risks: any
    width?: number,
    height?: number
}
 
export interface Point {
    x: number,
    y: number
}
